<template>
  <div id="Header">
    <div class="HeaderPosition">
      <div class="header-contnet">
        <div class="logo" @click="goIndex()">
          <div>
            <img :src="logoUrl" alt>
          </div>
        </div>
        <a-dropdown :trigger="['click']" class="bars">
          <a href="javascript:;">
            <a-Icon type="menu-unfold"/>
          </a>
          <a-menu slot="overlay">
            <a-menu-item @click="menusClick(1)">首页</a-menu-item>
            <!-- <a-menu-item
              v-for="(item,index) in gameItem"
              :key="index"
              @click="moreGameDetail(item)"
            >
              <a href="javascript:;">{{item}}</a>
            </a-menu-item> -->
            <a-menu-item @click="menusClick(3)">关于我们</a-menu-item>
          </a-menu>
        </a-dropdown>

        <div class="menus">
          <div class="menusItemActive" ref="actives" v-show="isMenuActive"></div>
          <div @click="menusClick(1)" ref="home" class="menusItem" :style="{'color':active==1?'#ffffff':''}">首页</div>
          <!-- <a-dropdown
            :trigger="['click']"
            class="menusItem"
            :style="{'color':active==2?'#ffffff':''}"
          >
            <a @click="menusClick(2)" ref="game" href="javascript:;">游戏</a>
            <a-menu slot="overlay">
              <a-menu-item
                v-for="(item,index) in gameItem"
                :key="index"
                @click="moreGameDetail(item)"
              >
                <a href="javascript:;">{{item}}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
          <div
            @click="menusClick(3)"
            class="menusItem"
            :style="{'color':active==3?'#ffffff':''}"
            ref="about"
          >关于我们</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Dropdown, Menu, Icon } from "ant-design-vue";
export default {
  name: "Header",
  data() {
    return {
      logoUrl: require("@/assets/logo.png"),
      // gameItem: ["街球艺术:3对3", "欢乐宠物店", "大家来找碴", "腹黑Q神传"],
      isMenuActive: true,
      that: this,
      active: 1,
      HeaderPosition: false
    };
  },
  components: {
    aDropdown: Dropdown,
    aMenu: Menu,
    aMenuItem: Menu.Item,
    aIcon: Icon
  },
  watch: {
    "$route.path": function(newValue, oldValue) {
      if (
        newValue !== "/" &&
        newValue !== "/About" &&
        newValue !== "gameDetail"
      ) {
        this.isMenuActive = false;
        this.active = 0;
      };
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    this.menusClick(1);
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= 60) {
        this.HeaderPosition = true;
      } else {
        this.HeaderPosition = false;
      }; 
    },
    menusClick(item) {
      let Info = {};
      switch (item) {
        case 1:
          Info.left = 0;
          // Info.width = this.$refs.home.getBoundingClientRect().width;  
          this.$router.push("/");
          break;
        // case 2: 
        //   Info.left = this.$refs.home.getBoundingClientRect().width; 
        //   Info.width = this.$refs.game.getBoundingClientRect().width;
        //   break;
        case 3: 
          // Info.width = this.$refs.about.getBoundingClientRect().width; 
          // Info.left = this.$refs.home.getBoundingClientRect().width + this.$refs.game.getBoundingClientRect().width;
          this.$router.push("/About");
          break;
        default:
          lefts = 0;
          break;
      }
      this.active = item;
      this.isMenuActive = true; 
      this.$refs.actives.style.transform = `translateX(${Info.left}px)`;
      this.$refs.actives.style.width = `${Info.width}px`;
    },
    goIndex() {
      this.$router.push("/");
      this.menusClick(1);
    },
    // moreGameDetail(item) {
    //   this.$router.push({ path: "/gameDetail", query: { gameName: item } });
    // }
  }
};
</script>
<style lang="stylus" scoped>
@import './common.styl';

@media screen and (max-width: 650px) {
  #Header {
    padding: 0px 10px 0px 0px !important;
  }
}

.HeaderPosition {
  position: fixed;
  top: 0; 
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.4);
  z-index: 999; 
  height:60px; 
  width:100%;
  padding: 0px 50px;
  flex-center(); 
  background-image:url("../../assets/index_line.png");
  background-color:rgba(166,204,254,1);
}

#Header {
  width: 100%;
  height: 60px;  
  background:#a6ccfe;
  .header-contnet {
    flex-between();
    width: 1080px;
    height:100%;
    position: relative;
  }

  .logo {
    width: 140px;
    height: 100%;
    cursor: pointer;
    position: relative;
    z-index: 1; 
    img {
      width: 180px;
    }

    div {
      position: absolute;
      width: 200px;
      height: 88px;
      top: -6px;
      background: #D1DEFF;
      border-radius: 0px 0px 16px 16px;
      display: flex;
      align-items: center;
      justify-content: center; 
    }
  }

  .bars {
    font-size: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
    display: none;
  }

  .menus {
    flex-end();
    align-items: center;
    font-size: 18px;
    position: relative; 
    z-index: 10;  
    .menusItem {
      padding: 0px 20px;
      cursor: pointer;
      color: #5A83B8;
      position: relative;
      z-index: 10;
    }
  }

  .menusItemActive { 
    height: 100%;
    position: absolute;
    bottom: 0px;
    left: 0px;
    background: #6AAAFE;
    transition: 0.2s linear;
    border-bottom: 2px solid #fff;
    z-index: 1;
  }
}

// 屏幕小于650px
@media screen and (max-width: 650px) {
  .bars {
    display: block !important;
    padding-right: 10px;
    line-height: 60px;
    color: #ffffff;
  }

  .logo {
    img {
      width: 130px !important;
    }

    div {
      width: 140px !important;
    }
  }

  .menus {
    display: none !important;
  }
}

// 屏幕小于1080px
@media screen and (max-width: 1080px) {
  #Header , .HeaderPosition{
    padding: 0 !important;
  }
 
  .header-contnet {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Header.vue